import React, { memo } from 'react';
import { AlertProps } from 'antd';
import { isMonsEnv } from '@xbcb/ui-env';
import { useCurrentUser } from 'libs/hooks';
import { StyledAlert } from './styles';
import {
  getAglCentralDomainForStage,
  getMonsDomainForStage,
  isAmazonEmail,
} from 'libs/userMigrationTools';
import { isExternalUserBannerEnabled } from 'featureFlags';
interface BannerConfig {
  message: string;
  type: AlertProps['type'];
  action: () => void;
}

// exported only for testing
export const BANNER_CONFIGS: Record<'internal' | 'default', BannerConfig> = {
  internal: {
    message: `Amazon employees should now log in to CBMS with Midway at ${getMonsDomainForStage()}. Click here to redirect.`,
    type: 'info',
    action: () => {
      const domain = getMonsDomainForStage();
      window.location.href = `https://${domain}${window.location.pathname}`;
    },
  },
  default: {
    message: `The CBMS URL that you are using will soon be retired.   
    Please migrate your account by clicking this banner.  Access CBMS via https://${getAglCentralDomainForStage()} in the future.`,
    type: 'info',
    action: () => {
      const domain = getAglCentralDomainForStage();
      window.location.href = `https://${domain}/migrate`;
    },
  },
};

export const SSOBanner: React.FC = () => {
  const isMons = isMonsEnv();
  const user = useCurrentUser();

  if (!user?.email || isMons) return null;

  const configKey = isAmazonEmail(user.email) ? 'internal' : 'default';

  if (configKey === 'default' && !isExternalUserBannerEnabled()) return null;

  const config = BANNER_CONFIGS[configKey];

  return (
    <StyledAlert
      type={config.type}
      message={config.message}
      onClick={() => config.action()}
    />
  );
};

export default memo(SSOBanner);
